import { render, staticRenderFns } from "./MyAccountGeneralSecurity.vue?vue&type=template&id=70f61463&scoped=true&"
import script from "./MyAccountGeneralSecurity.vue?vue&type=script&lang=js&"
export * from "./MyAccountGeneralSecurity.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountGeneralSecurity.vue?vue&type=style&index=0&id=70f61463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f61463",
  null
  
)

export default component.exports